import React, { useCallback, useRef, useState } from 'react';
import { ToastContext } from '../../hooks/useToast';
import './Toast.css';
let _seq = 0;
const ToastProvider = ({ children, duration = 3000 }) => {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});
  const remove = useCallback((id) => { setToasts((p)=>p.filter((t)=>t.id!==id)); if (timers.current[id]) { clearTimeout(timers.current[id]); delete timers.current[id]; } }, []);
  const push = useCallback((type, message) => { const id=++_seq; setToasts((p)=>[...p,{id,type,message}]); timers.current[id]=setTimeout(()=>remove(id), duration); }, [duration, remove]);
  const api = useRef({});
  api.current.success = (msg) => push('success', msg);
  api.current.error = (msg) => push('error', msg);
  return (
    <ToastContext.Provider value={api.current}>
      {children}
      <div className="toast-container" aria-live="polite">
        {toasts.map((t) => (<div key={t.id} className={`toast toast-${t.type}`} role="status" onClick={()=>remove(t.id)}>{t.message}</div>))}
      </div>
    </ToastContext.Provider>
  );
};
export default ToastProvider;
